

import React from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./Toaster.css";

const Toaster = () => {
    const notifyMultiple1 = () => {
        toast.success("Success Notification!", {
        position: "top-right",
        });
        
    };
    const notifyMultiple2 = () => {
        toast.error("Error Notification!", {
        position: "bottom-right",
        });
    };

  return (
    <div>
        <div className="m-2 d-inline-block">
            <button onClick={notifyMultiple1} className="btn btn-primary">
                Toaster 1
            </button>
            {/* ToastContainer is mandatory to display the toasts */}
            <ToastContainer />
        </div>
        <div className="m-2 d-inline-block">
            <button onClick={notifyMultiple2} className="btn btn-danger">
                Toaster 2
            </button>
            {/* ToastContainer is mandatory to display the toasts */}
            <ToastContainer />
        </div>
    </div>
  );
};

export default Toaster;
